import { SIGNUP_REQUESTED, SIGNUP_FAILED, SIGNUP_SUCCESS } from '../actionCreators/authActions';
import { RESET_STATE } from '../actionCreators/generalActions';

const initialState = {
  processing: false,
  signUpSuccess: false
};

function signupReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case SIGNUP_REQUESTED:
      const error = undefined;

      return {
        ...state,
        processing: true,
        signUpSuccess: false,
        error
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        processing: false,
        signUpSuccess: true
      };
    case SIGNUP_FAILED:
      const signUpError = action.error.err;
      return {
        ...state,
        processing: false,
        signUpSuccess: false,
        error: signUpError
      };
    case RESET_STATE:
      return { ...initialState };

    default:
      return state;
  }
}

export default signupReducer;
